import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scores", "points", "frags", "places", "points_calculation_table", 'prize_total', 'prize', 'prize_percentage']

  get_percentage(event) {
    let value = parseFloat(this.prizeTarget.value)
    let total = parseFloat(this.prize_totalTarget.innerHTML)
    
    if (!total || total == 0) {
      return
    }

    if (!this.hasPrize_percentageTarget) {
      return
    }

    if (this.prizeTarget.value.indexOf('%') > -1)
    {
      this.prize_percentageTarget.innerHTML = this.prizeTarget.value
    } else {
      let result = parseFloat(100.0*value/total).toFixed(1)
      this.prize_percentageTarget.innerHTML = (result > 0 ? `${result}%`: '0.0%')
    }
  }

  fill_points(event) {
    event.preventDefault()
    const table = this.points_calculation_tableTarget.dataset.value.split(',')
    this.pointsTargets.forEach((pointsEl, index) => {
      if (table[index] && table[index] !=0 ) {
        pointsEl.value = table[index]
      }
    })
  }

  add_points(event) {
    event.preventDefault()
    const table_str = this.points_calculation_tableTarget.dataset.value.split(',')
    let table = []
    
    table_str.forEach((el, index) => {
      table.push(el - 0)
    })
    const points_for_one_frag = table[0] - 0
    let places_map = {}
    let points_map = {}
    let used_places_arr = []
    
    this.pointsTargets.forEach((pointsEl, index) => {
      let place = this.scoresTargets[index].value - 0
      places_map[index] = place
      points_map[place] = table[place] - 0
      used_places_arr.push(place)
    })

    let last_place = 0
    let last_place_duplication_count = 0
    let last_place_points_sum = 0
    used_places_arr.sort().forEach((el, index) => {
      if (last_place == el) {
        last_place_duplication_count++
        if (last_place_duplication_count == 1) {
          last_place_points_sum = table[el]
        }
        last_place_points_sum += table[index+1]
      } else if (last_place_duplication_count > 0) {
        points_map[last_place] = last_place_points_sum / (last_place_duplication_count + 1)
        points_map[last_place] = Number((Math.round(points_map[last_place] * 100)/100).toFixed(1))
        last_place_duplication_count = 0
        last_place_points_sum = 0
      }
      last_place = el  
    })

    this.pointsTargets.forEach((pointsEl, index) => {
      let place = places_map[index]
      let points = points_map[place]

      if (place > 0) {
        this.fragsTargets.forEach((fragsEl, index) => {

          if (fragsEl.name.startsWith(pointsEl.name.replace("[points_with_penalty]",''))) {
            let frags = fragsEl.value - 0
            if (frags > 0) {
              points += points_for_one_frag * frags
            }
          }
        })

        if (points >= 0) {
          pointsEl.value = points
        }
      }
    })

    $(document).Toasts('create', {
      autohide: true,
      position: 'bottomLeft',
      delay: 3000,
      title: event.target.dataset.title,
      body: event.target.dataset.message,
      class: 'bg-success'
    })
  }
}
